import { Navigate, Route, Routes } from 'react-router-dom';

import withPermission from 'hooks/withPermission';

import { PATH } from 'constants/path';

import { ClassDetailLayout } from './components/ClassDetailLayout';
import { AssessmentDetail } from './page/AssessmentDetail';
import { CalendarPage } from './page/CalendarPage';
import ClassesAddPage from './page/ClassesAddPage';
import { ClassesDetailPage } from './page/ClassesDetailPage';
import { ClassesMembersPage } from './page/ClassesMembersPage';
import { ClassesPage } from './page/ClassesPage';
import { LearnerScorePage } from './page/LearnerScorePage';
import { LessonDetailPage } from './page/LessonDetailPage';
import { LessonsAssessmentPage } from './page/LessonsAssessmentsPage';

const ClassesRoutes = () => {
  return (
    <Routes>
      <Route>
        <Route index element={<ClassesPage />} />
        <Route path={PATH.CLASSES_ADD} element={<ClassesAddPage />} />
        <Route path={`/${PATH.CLASSES_DETAIL}/*`} element={<ClassDetailLayout />}>
          <Route path={PATH.CLASSES_EDIT} element={<ClassesDetailPage />} />
          <Route path={PATH.CLASSES_MEMBERS} element={<ClassesMembersPage />} />
          <Route path={PATH.CLASSES_LESSONS} element={<LessonsAssessmentPage />} />
          <Route path={PATH.CLASSES_CALENDAR} element={<CalendarPage />} />
        </Route>
        <Route
          path={`${PATH.CLASSES_DETAIL}/${PATH.CLASSES_MEMBERS}/${PATH.LEARNER_SCORE}`}
          element={<LearnerScorePage />}
        />
        <Route
          path={`${PATH.CLASSES_DETAIL}/${PATH.CLASSES_LESSONS}/${PATH.LESSON_DETAIL}`}
          element={<LessonDetailPage />}
        />
        <Route
          path={`${PATH.CLASSES_DETAIL}/${PATH.CLASSES_LESSONS}/${PATH.ASSESSMENT_DETAIL}`}
          element={<AssessmentDetail />}
        />
        <Route path="*" element={<Navigate to={PATH.ERROR_404} />} />
      </Route>
    </Routes>
  );
};

export default withPermission(['Classes'])(ClassesRoutes);
